var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowCompleteButton)?_c('div',{staticClass:"patent-view__side-function-task"},[_c('button',{staticClass:"pt-ui-btn",attrs:{"data-type":_vm.isDone ? 'default' : 'primary',"disabled":_vm.isDone || _vm.isLoadingList || _vm.isSubmitting},on:{"click":_vm.doneReview}},[_vm._v("\n        "+_vm._s(_vm.submitText)+"\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }